import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { DEFAULT_FIELD_DISPLAY } from '../utils/fieldDisplay';
import { extractErrorMessage } from '../utils/apiErrors';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/field/preferences/me`;

export default function useFieldDisplayPreferences(user) {
  const [preferences, setPreferences] = useState(DEFAULT_FIELD_DISPLAY);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const identity = `${user?.organization_id}:${user?.id}`;
  const currentIdentity = useRef(identity);
  currentIdentity.current = identity;
  useEffect(() => {
    const controller = new AbortController();
    setPreferences(DEFAULT_FIELD_DISPLAY); setLoading(true); setError('');
    axios.get(API, { signal: controller.signal }).then((r) => setPreferences(r.data)).catch((err) => {
      if (!controller.signal.aborted) setError(extractErrorMessage(err, 'Unable to load your display preferences'));
    }).finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [identity, attempt]);
  const save = useCallback(async (value) => {
    const res = await axios.put(API, value);
    if (currentIdentity.current === identity) setPreferences(res.data);
    return res.data;
  }, [identity]);
  return { preferences, loading, error, save, retry: () => setAttempt((v) => v + 1) };
}